import React from 'react';

import Text from 'components/Text';

import styled from 'styled-components';
import { mobile, tablet, useQuery } from 'styles/breakpoints';
import { DynamicImage, PrimaryButton } from 'components';
import ContinueButton from './QuizContinueButton';
import { useSelector } from 'react-redux';
import { AppState } from 'state/types';
import quizSvgs from 'utils/constants/quizSvgs';

const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-grow: 1;
  max-width: 28.8rem;
  width: 100%;
  padding: 3.5rem 0 7rem;
  @media ${tablet} {
    padding: 1.5rem 0;
    padding-bottom: 85px;
  }
  @media ${mobile} {
    padding: 1.5rem 1rem;
  }
`;

const StyledImg = styled(DynamicImage)`
  width: 100%;
  margin-bottom: 1.25rem;
  @media ${tablet} {
    margin-bottom: 0.75rem;
  }
`;

const RowBox = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 1.25rem;
  @media ${tablet} {
    margin-bottom: 0.75rem;
  }
`;

const Description = styled(Text)`
  color: #fff;
  text-align: center;
  font-size: 1rem;
  font-style: normal;
  font-weight: 300;
  line-height: 1.5rem;
  @media ${tablet} {
    font-size: 0.875rem;
  }
`;

const DescriptionBottom = styled(Description)`
  margin-top: 0.75rem;
  @media ${tablet} {
    line-height: 1.375rem;
  }
`;

const Title = styled(Text)`
  color: #f7c800;
  text-align: center;
  font-size: 2.375rem;
  font-style: normal;
  font-weight: 700;
  line-height: 2rem;
  text-transform: capitalize;
  padding: 1.25rem 0;
  @media ${tablet} {
    font-size: 1.75rem;
    padding: 1.5rem 0 0.75rem;
  }
`;

const Content = styled.div`
  border-radius: 1.5rem;
  border: 1px solid rgba(132, 141, 159, 0.57);
  background: #001736;
  display: flex;
  padding: 3rem 1.5rem;
  flex-direction: column;
  align-items: center;
  align-self: stretch;
  max-width: 28.75rem;
  width: 100%;
  margin: 0 auto;
  svg {
    width: 20rem;
    height: unset;
  }
  @media ${tablet} {
    max-width: 21.4375rem;
    padding: 2.375rem 1.5rem;
    svg {
      width: 12.5rem;
    }
  }
`;

const ButtonStyled = styled(PrimaryButton)`
  max-width: 228.75rem;
  width: 100%;
  margin-top: 2.5rem;
  @media ${tablet} {
    margin-top: 1.69rem;
  }
`;

const DynamicImageStyled = styled(DynamicImage)`
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  z-index: -1;
`;

type InfoTopImageProps = {
  text: any;
  backgroundImage: string;
  buttonTitle: string;
  onContinue: () => void;
};

const ZodiacInfo = ({
  text,
  onContinue,
  backgroundImage,
  buttonTitle,
}: InfoTopImageProps) => {
  const quizAnswers = useSelector((state: AppState) => state.user.quiz_answers);
  const { isTablet, isMobile } = useQuery();
  const zodiacSign = quizAnswers?.zodiacSign;
  const renderSvgImage = (svgKey: string) => {
    const Svg = quizSvgs[svgKey];
    return <Svg />;
  };
  return (
    <Container>
      {/* <DynamicImageStyled src={backgroundImage} alt=""  objectFitOpt="cover"/> */}
      <Content>
        {renderSvgImage(zodiacSign)}
        <Title>{zodiacSign}</Title>
        <Description>
          {text[`${zodiacSign}_${quizAnswers?.gender}`]}
        </Description>
      </Content>
      <ButtonStyled onClick={onContinue}>{buttonTitle}</ButtonStyled>
    </Container>
  );
};

export default ZodiacInfo;
